import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import config from '../config';

interface Facility {
  id: number;
  suggestion: string;
  initials: string;
}

export function Login() {
  const [facilities, setFacilities] = useState<Facility[]>([]);
  const [selectedFacility, setSelectedFacility] = useState<Facility | null>(null);
  const [error, setError] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    fetch(`${config.API_URL}/suggestions/all_facilities`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch facilities');
        }
        return response.json();
      })
      .then(data => {
        setFacilities(data);
        setError('');
      })
      .catch(error => {
        console.error('Error fetching facilities:', error);
        setError('Failed to load facilities. Please try again later.');
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleFacilityChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const facility = facilities.find(f => f.id === parseInt(event.target.value));
    setSelectedFacility(facility || null);
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (selectedFacility) {
      localStorage.setItem('selectedFacilityId', selectedFacility.id.toString());
      localStorage.setItem('facilityInitials', selectedFacility.initials);
      navigate('/');
    }
  };

  return (
    <div className="container">
      <h1>Select Facility</h1>
      {error && <div className="error">{error}</div>}
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="facility">Select Facility:</label>
          <select
            id="facility"
            value={selectedFacility?.id || ''}
            onChange={handleFacilityChange}
            required
            disabled={loading}
          >
            <option value="">Choose a facility...</option>
            {facilities.map(facility => (
              <option key={facility.id} value={facility.id}>
                {facility.suggestion}
              </option>
            ))}
          </select>
        </div>

        <button type="submit" className="submit-button" disabled={loading || !selectedFacility}>
          {loading ? 'Loading...' : 'Continue'}
        </button>
      </form>
    </div>
  );
}